import { Typography } from 'antd';
import React, { useMemo } from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ICompanyWidget } from './ICompanyWidget';

export interface ICompanyWidgetComponentProps
  extends IWidgetComponentProps<ICompanyWidget> {}

export function CompanyWidgetComponent(props: ICompanyWidgetComponentProps) {
  const options = useMemo(() => getWidgetProps(props), [props]);

  return (
    <>
      {options.preview && (
        <div>
          <Typography.Text type="secondary">
            Configurando un&apos;azienda in questo elemento impostando i campi
            con i relativi &quot;Attributo del titolare della richiesta&quot;,
            tutti i titolari della richiesta presenti all&apos;interno di questo
            elemento saranno collegati all&apos;azienda configurata come legali
            rappresentati.
          </Typography.Text>
        </div>
      )}
      {props.children}
    </>
  );
}
